import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';
import {getBookingFiltersIsCancelledStatus} from '@utils/booking';

export const CancellationStatusFilter = ({
    loading = false,
    filters,
    restoreFilterValues,
}) => (
    <Field
        component={Form.ReduxSelect}
        name='isCancelled'
        placeholder='Cancellation status'
        options={getBookingFiltersIsCancelledStatus()}
        search
        loading={loading}
        disabled={loading}
        setValue={restoreFilterValues(filters, 'isCancelled', 0)}
    />
);

CancellationStatusFilter.propTypes = {
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};
